import { getQaSelector } from '../../../utils/common'
import { htmlToMultilineText } from '../../../utils/html'
import { FloatingTooltip } from '../../Floating'
import { ICON_HEIGHT_20, IconNG } from '../../Icon'
import Text from '../../Text'

import { QA_NAME_TABLE_CELL_NOTE } from './TableCellNote.constants'

import * as styles from './TableCellNote.module.css'

import NoteIcon from '../../../icons/note-2.svg'

function TableCellNote({
  Icon = NoteIcon,
  className = styles.TableCellNote,
  iconSize = ICON_HEIGHT_20,
  markup,
  qaName,
  value,
}) {
  const qaProps = getQaSelector({
    context: QA_NAME_TABLE_CELL_NOTE,
    def: QA_NAME_TABLE_CELL_NOTE,
    value: qaName,
  })

  return (
    <FloatingTooltip content={value} markup={markup}>
      <div {...qaProps} className={className}>
        <IconNG Icon={Icon} size={iconSize} />
        <Text className={styles.noteText}>
          {markup ? htmlToMultilineText(value) : value}
        </Text>
      </div>
    </FloatingTooltip>
  )
}

export default TableCellNote
